import AltTitle from "../components/ui/AltTitle";
import StrokeTitle from "../components/ui/StrokeTitle";
import { useState } from "react";
import "swiper/scss";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/autoplay";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Modal from "../components/ui/Modal";
import FlowerTitle from "../components/ui/FlowerTitle";

const Plus = () => {
  
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    size: 6
  })

  const [dlcModal, setDLCModal] = useState({
    visible: false,
    current: 0,
    size: 1
  })

    const [endModal, setEndModal] = useState({
    visible: false,
    current: 0,
    size: 6
  })

  const location = useLocation();
  
  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Remove the # character
      const id = location.hash.substring(1);
      
      // Find the element
      const element = document.getElementById(id);
      
      // If the element exists, scroll to it
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // No hash - scroll to top when navigating to this page
      window.scrollTo(0, 0);
    }
  }, [location.hash]);



  return (
    <div className="page-container">
      
    <FlowerTitle text="What's New"/>
      <Modal modal={modal} setModal={setModal} url="additional_content_ss_0.jpg"/>
      <Modal modal={dlcModal} setModal={setDLCModal} url="dlc-comp.png"/>
      <Modal modal={endModal} setModal={setEndModal} url="end_content_ss_0.jpg"/>
      <AltTitle text="Disgaea 7 Complete is jam-packed with content, including the original Disgaea 7: Vows of the Virtueless game and all previously-released DLC, along with new stories, characters, and more!" specialClass="plus-top"/>
      <div className="title-accent accent-left">
        <h5 className="black-yellow-text fade-in">Complete Feature #1!</h5>
        <StrokeTitle text="All-New Stories and Characters"/>
      </div>
      <h1 className="black-yellow-text" style={{fontSize: '1.75em', textAlign: 'center', marginBottom: '25px', maxWidth: '95vw'}}>
        Classic Characters Team Up with the Nethertime Support Force!
       </h1>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_01.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_02.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_03.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_04.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 4,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
        Fuji and his Disgaea 7: Vows of the Virtueless friends visit Netherworlds from past titles!? <br/> After the main story concludes, the group sets out to save the souls still trapped inside the Infernal Treasures, leaving not only Ewwdo, but the entire world of Disgaea 7: Vows of the Virtueless behind!
        </p>
      </div>
      <h3 className="black-yellow-text header-text"
        style={{
            fontSize: '2em',
            maxWidth: '850px',
            width: '95vw',
            padding: '25px 0px',
            textAlign: 'center'
        }}
      >
         Asagi Joins the Fray!
      </h3>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_05.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 5,
            }
          )
        }}/>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/additional_content_ss_06.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 6,
            }
          )
        }}/>
      </div>

      <div className="text-wrapper" style={{marginBottom: '0px'}}>
        <p className="white-text">
            Clear the Nethertime Support Force story and a new character, <span style={{color: '#f2cc21'}}>Asagi</span>, will be added to your party.
        </p>
      </div>

      <div className="text-wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: "row",
          flexWrap: 'wrap'
        }}
      >
        <p className="white-text"
          style={{
            maxWidth: '600px'
          }}
        >
            "Who's Asagi?" you ask? <br/>
            You may know her from her bevy of guest appearances in the Disgaea series and other Nippon Ichi Software, Inc. titles.<br/>
            <span style={{color: '#f2cc21'}}>
                She is the (self-proclaimed) eternal next main character.
            </span>
        </p>
        <img 
          style={{
            maxWidth: '200px',
            width: '90vw',
            filter: 'drop-shadow(0px 0px 10px white)'
          }}
        src={`${process.env.PUBLIC_URL}/img/plus/asagi.png`} alt="Asagi" />
      </div>
      <div id="dlc" className="title-accent accent-left" style={{paddingTop: '15px'}}>
        <h5 className="black-yellow-text fade-in"
        >Complete Feature #2!</h5>
        <StrokeTitle text="All Previous DLC and Bonus Content"/>
      </div>
        <img 
            style={{maxWidth: '850px'}}
        className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/dlc-comp.png`} alt="Includes all DLC characters and scenarios previously released for Disgaea 7: Vows of the Virtueless!" 
        onClick={()=>{
            setDLCModal(
            {
                ...dlcModal,
                'visible': true,
                'current': 1,
            }
            )
        }}/>
      <div className="text-wrapper">
        <p className="white-text">
        And we mean everything! The 7 bonus stories, the 22 new characters, the <span style={{color: '#f2cc21'}}>bonus perk-exclusive costumes</span>, and the <span style={{color: '#f2cc21'}}>special costumes!</span> They're aaallllll here!

        </p>
      </div>

      <div className="content-wrapper">
          <h3 className="black-yellow-text"
            style={{
              filter: 'drop-shadow(0px 0px 4px black)'
            }}
          >Included Content:</h3>
          <ul className="black-white-text">
            <li>・Bonus Stories (21 Additional Characters)</li>
            
            <li>・Bonus Character: Pleinair</li>
            
            <li>・Glasses Costumes</li>
            
            <li>・Special Weapons Set</li>
            
            <li>・Disgaea Costumes Set</li>
            
            <li>・14 Additional Generic Unit Costumes</li>
          </ul>
      </div>
      <div className="title-accent accent-left" style={{paddingTop: '25px'}}>
        <h5 className="black-yellow-text fade-in"
        >Complete Feature #3!</h5>
        <StrokeTitle text="Even More Disgaea Goodness"/>
      </div>
      <div className="text-wrapper">
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
        <span style={{color: '#f2cc21'}}>Next-Level Hell Mode</span><br/>
        We listened to the fans and added more <span style={{letterSpacing: '1px'}}>fl</span>exibility for taking your characters to the next level...<br/> 
        That's right - Hell Mode is now available for everyone!


        </p>
      </div>
        <div className="pair" style={{
          alignItems: "flex-start"
        }}>
          <div className="item">
             <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_01.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Pass a bill in the Dark Assembly to enable any and all characters to use Hell Mode.
          </h3>
          </div>
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_02.jpg`} alt="Top-SS" onClick={()=>{
              setEndModal(
                {
                  ...endModal,
                  'visible': true,
                  'current': 2,
                } 
              )
            }}/>
                    <h3 className="item-text white-text">
            Equip the Demonic Spear, Banji Tadakatsu, to act three times in one turn while in Hell Mode, and even a lowly Prinny will be a force to be reckoned with!

          </h3>
          </div>
        </div>
        <div className="content-wrapper">
          <span
            className="black-white-text"
            style={{fontFamily: 'yuji-syuku', color: '#ff5269', fontWeight: 600}}
          >Unlock Requirement:</span><br/><br/>
          <p className="black-white-text"
            style={{fontFamily: 'yuji-syuku', fontWeight: 600}}
          >
            After clearing the main game, pass the "Freely Use Infernal Treasures!" bill.
          </p>
        </div>
        <div className="text-wrapper" style={{marginBottom: '50px'}}>
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
        <span style={{color: '#f2cc21'}}>New Max Stats</span><br/>
        Go above and beyond when creating your ultimate character with new maximum limits for stats!
        </p>
      </div>
              <div className="pair" style={{
          alignItems: "flex-start"
        }}>
          <div className="item">
             <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_03.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Leveling up your favorite characters to your heart's content is the bread and butter of the Disgaea series.
          </h3>
          </div>
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_04.jpg`} alt="Top-SS" onClick={()=>{
              setEndModal(
                {
                  ...endModal,
                  'visible': true,
                  'current': 4,
                } 
              )
            }}/>
            <h3 className="item-text white-text">
            With this over-the-top leveling, even a humble Prinny can bring the pain!
          </h3>
          </div>
        </div>
                <div className="content-wrapper">
          <span
            className="black-white-text"
            style={{fontFamily: 'yuji-syuku', color: '#ff5269', fontWeight: 600}}
          >Unlock Requirement:</span><br/><br/>
          <p className="black-white-text"
            style={{fontFamily: 'yuji-syuku', fontWeight: 600}}
          >
            After clearing Carnage Baal's Manifestation, pass the <span style={{color: '#f2cc21'}}>"Take Me Beyond the Limits!"</span> bill.
          </p>
        </div>
        <div className="text-wrapper" style={{marginBottom: '50px'}}>
          <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
          <span style={{color: '#f2cc21'}}>The Ultimate Boss, Rakshasa Baal </span><br/>
          <span style={{color: '#f2cc21'}}>Rakshasa Baal</span> appears from another dimension, boasting even more fearsome strength than that wimpy Carnage Baal guy! Use your battle-hardened party to take on the ultimate evil! 
          </p>
        </div>
              <div className="pair" style={{
          alignItems: "flex-start"
        }}>
             <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_05.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/end_content_ss_06.jpg`} alt="Top-SS" onClick={()=>{
              setEndModal(
                {
                  ...endModal,
                  'visible': true,
                  'current': 6,
                } 
              )
            }}/>
        </div>
          <div className="content-wrapper">
          <span
            className="black-white-text"
            style={{fontFamily: 'yuji-syuku', color: '#ff5269', fontWeight: 600}}
          >Unlock Requirement:</span><br/><br/>
          <p className="black-white-text"
            style={{fontFamily: 'yuji-syuku', fontWeight: 600}}
          >
            After clearing Carnage Baal's Manifestation, pass the <span style={{color: '#f2cc21'}}>"Fight a Next-Level Super Overlord!"</span> bill.
          </p>
        </div>
    </div>

  )
}

export default Plus;